/** @jsx jsx */
import { gql } from '@apollo/client';
import { P } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function ProductVinification({ product, ...rest }) {
  if (!product?.vinification) return null;
  return (
    <Section title={<Trans>Vinification</Trans>} {...rest}>
      {product.vinification.split('\n\n').map((p, index) => (
        <P key={index} variant="large">
          {p}
        </P>
      ))}
    </Section>
  );
}

export const fragment = graphql`
  fragment bb_WineVinification on Bottlebooks_Wine {
    vinification
  }
`;

export const ProductVinificationFragment = gql`
  fragment ProductVinification on Wine {
    vinification
  }
`;
